export const positionLeft = (index, active) => {
    if (index >= active) {
        return { left: "100px" }
    } else {
        return { left: "-100px" }
    }
}

export const isSelected = (value, valueCurrent) => {
    return valueCurrent === value ? "active" : "";     
}
export const isChecked = (array_values, value) => {

    let results = [];
    for(let i=0; i<array_values.length; i++) {
      for(let key in array_values[i]) {
        if(array_values[i][key].indexOf(value)!=-1) {
          results.push(array_values[i]);
        }
      }
    }

    if(Object.keys(array_values).length === 0){ return false; }
    if(Object.keys(results).length !== 0){
        return true;
    }else{
        return false;
    }
}
export const isActive = (status) =>{
    return status === "trimester" ? "" : "hide";
} 
export const isActiveSlide = (current, slide, type) =>{
    return current === slide ? "active" : "";
} 
export const advBookSeries = [
    { key : "1 - 30 DAYS" , value: "serie_30" },
    { key : "31 - 60 DAYS" , value: "serie_60" },
    { key : "61 - 90 DAYS" , value: "serie_90" },
    { key : "91 - 120 DAYS" , value: "serie_120" },
    { key : "+120 DAYS" , value: "serie_120_more" },
];
export const isActiveSidebar = (current_sidebar, to_active) =>{
    const validate = (current_sidebar === to_active)
    return validate === false ? " hide" : "";
}

export const isPickupSection = (app) => {
    let validate = false;
    if(app !== null){
        if(app.state.panel === "review"){
            if(app._LayoutReview !== undefined && app._LayoutReview !== null){
                if(app._LayoutReview.state.active_slide.key === "pickup"){
                    validate = true;
                }else{
                    validate = false
                }
            }
        }
        return validate;
    }
} 

export const componentActive = (app, require_panel) => {
    if(app !== null){
        let validate = (require_panel.indexOf(app.state.panel) !== -1) ? true : false;
        if(app.state.panel === "review"){
            if(app._LayoutReview !== undefined && app._LayoutReview !== null){
                if(app._LayoutReview.state.active_slide.key === "pickup"){
                    validate = false;
                }
            }
        }
        return validate === false ? " hide" : "";
    }
} 
export const subComponentActive = (app, require_panel) => {
    if(app !== null){
        let validate = false;
        if(app.state.panel === "review"){
            if(app._LayoutReview !== undefined && app._LayoutReview !== null){
                if(app._LayoutReview.state.active_slide.key === require_panel){
                    validate = true;
                }else{
                    validate = false
                }
            }
        }
        return validate === false ? " hide" : "";
    }
} 
export const isActiveChannel = (skip_channels, current_filters_channel, channel) => {
    if(Object.keys(current_filters_channel).length === 0){
        if (skip_channels[channel] === undefined){
            return "active"
        }else{
            return "inactive"
        }
    }else if(Object.keys(current_filters_channel).length > 0){
        if(current_filters_channel[channel] === undefined){
           return false
        }else if (skip_channels[channel] !== undefined){
            return "inactive"
        }else{
            return "active"
        } 
    }else{
        return "inactive"
    } 
} 
export const current_year = () =>  {
    return localStorage.getItem('current_year')
};

export const past_year = () => {
    return localStorage.getItem('past_year')
}

export const years_collection = () => {
    const years = JSON.parse("[" + localStorage.getItem('years_collection') + "]");
    return years
}

export const past_years_collection = () => {
    const years = JSON.parse("[" + localStorage.getItem('years_collection') + "]");
    return years.shift()
}

export const getMonthFormat = (month) => {
    let month_format;
    
    month_format = String(month).length < 2 ? "0" + month : month;
    
    return month_format;
}

export const getDayFormat = (day) => {
    let day_format;
    
    day_format = String(day).length < 2 ? "0" + day : day;
    
    return day_format;
}

export const channelApplyBtnShow = (comp, type) => {
    const array_global = Object.keys(comp[0]).length;
    const array_temp   = Object.keys(comp[1]).length;
    switch (type){
        case "filter":
            if(array_temp > 0){
                if(array_global === array_temp)
                {
                    return "hide"
                }
            }else{
                if(array_global === 0){
                    return "hide"
                }
            }
            break;
        case "default":
            if(array_global > 0){
                if(array_global !== array_temp)
                {
                    return "hide"
                }
            }else{
                return "hide"
            }
            break;
        default:
            break;
    }
}

export const  plan = [   
    { key : "AI" , value: "ai" },
    { key : "EP" , value: "ep" }
];


export const  room_types     = [ ];

export const  tariff_types   = [ ];

export const  agencies        = [ ];

export const  markets       = [
    { key : "Internacional" , value: "international" },
    { key : "Nacional" , value: "national" }
];


export const  reservas = [   
    { key : "Activa" , value: "vendida" },
    { key : "Dormida" , value: "dormida" },
    { key : "Cancelada" , value: "cancelada" },
    { key : "No Show" , value: "no_show" }
];

export const  periods = [   
    //{ key : "Elegir periodo" , value: "choice" },
    //{ key : "Hoy" , value: "today" },
    { key : "Año en curso", value : "current_year"},
    { key : "Acumulado" , value: "acm" },
    { key : "Ayer" , value: "yesterday" },
    //{ key : "Personalizado" , value: "custom" }
    
];

export const periodsComp = [   
    { key : "Periodo anterior" , value: 0 },
    { key : "Periodo anterior 1" , value: 1 },
    { key : "Periodo anterior 2" , value: 2 },
    { key : "Periodo anterior 3" , value: 3 }
];

export const days = [   
    { key : "Monday" , value: 1 },
    { key : "Tuesday" , value: 2 },
    { key : "Wednesday" , value: 3 },
    { key : "Thursday" , value: 4 },
    { key : "Friday" , value: 5 },
    { key : "Saturday" , value: 6 },
    { key : "Sunday" , value: 0 }
];

export const modules = [   
    { text : "REVENUE INTELLIGENCE" , icon: "icon-marketing", value : 1 },
    /* { text : "FINANCIAL" , icon: "icon-finance", value : 2 },
    { text : "HUMAN RESOURCES" , icon: "icon-rrhh", value : 3 },
    { text : "OPERATIONS" , icon: "icon-operations", value : 4 },
    { text : "F&B" , icon: "icon-ab", value : 5 },
    { text : "MARKET SHARE" , icon: "icon-marketshare", value : 6 },
    { text : "DESTINATIONS" , icon: "icon-destinities", value : 7 } */
];

export const views = [  
    { key : "Meses", value : "month" },
    { key : "Days de la semana", value : "days" },
    { key : "Trimestres", value : "trimester" },
    /*{ key : "Temporadas", value : "seasons" },
    { key : "Promociones", value : "promotions" }*/
];
export const leadtime_chart = [  
    { key : "Room Nigths", value : "room_night" },
    { key : "Revenue", value : "revenue" },
    { key : "ADR", value : "adr" }
];
export const options_compare = [
    { key : "Por año", value : "past_year" },
    { key : "Personalizado", value : "custom_past_year" }
]
export const status_reserve = [  
    { key : "Reservation Date", value : "date_nights" },
    { key : "Booking date", value : "date_book" },
];
export const months = [   
    "JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
];
export const  hotels = () => {
    const structure = JSON.parse(localStorage.getItem('user_roles'))

    return (structure === null) ? {} : structure
}
export const  hotel_has_panel = (hotel, panel) => {
    const structure = JSON.parse(localStorage.getItem('user_roles'))
    let status = false;
    
    if(structure !== null){
        Object.keys(structure).map(function(index){
            if(hotel === structure[index].hotel_id){
                const panels = structure[index].modules[0].panels
                Object.keys(panels).map(function(index_aux){
                    if(panel ===  panels[index_aux].value){
                        status = true;
                    }
                });
            }
        })
    }
    return status;
}


export function panels() {
    let structure = {}, max_panels = 0;
    if(JSON.parse(localStorage.getItem('user_roles')) !== null){
        const structure_aux = JSON.parse(localStorage.getItem('user_roles'));
        Object.keys(structure_aux).map(function(index){
            if(Object.keys(structure_aux[index].modules[0].panels).length > max_panels){
                max_panels = Object.keys(structure_aux[index].modules[0].panels).length
                structure = structure_aux[index].modules[0].panels;
            }
        })
        
    }
    return structure;
};

export const actionsFooter = [   
    { icon: "save", value : 1, tooltip: "NEW REPORT" },
    { icon: "model-generate", value : 2, tooltip: "GENERAR MODELO" },
    { icon: "share", value : 3, tooltip: "COMPARTIR" },
    { icon: "save-pdf", value : 4, tooltip: "EXPORTAR A PDF" },
];

export const daysYear = (min_interval, max_interval) => {
    let days = [];
    for (let index = min_interval; index <= parseInt(max_interval); index++) {
        days[index] = index;
    }
    return days;
}

export const dateFormat = (date) => {
    let date_format = (date.split(" ")[0]).split("-");
    date_format = date_format[2] + "/" + months[(parseInt(date_format[1]) - 1)] + "/" + date_format[0];
    return date_format;
}


export const number_format = (number, decimals, decPoint, thousandsSep) => {

  
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
  
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return '' + (Math.round(n * k) / k)
        .toFixed(prec)
    }
  
    // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length + 1).join('0')
    }
  
    return s.join(dec)
  }

export const windowsActive = (state, dashboard, slide) => {
    if(state.panel === dashboard && state.current_slide === slide){
        return true;
    }else{
        return false;
    }
}

export const is_better_arrow = (comp) => {
    return parseFloat(comp) !== 0 ? (parseFloat(comp) < 0 ? "worst" : "best") : "hide";
}

export const alertShow = (alerts) =>{
    if( alerts.alert_datepicker_error === "active" || alerts.alert_demo_version === "active" || alerts.alert_error_network === "active"){
        return "active"
    }else{
        return "inactive";
    }
}

export const modelReportShow = (models_reports) => {
    if (models_reports.alert_modal_model_list === "active" ||
        models_reports.alert_modal_report_list === "active" ||
        models_reports.alert_modal_model_new === "active" ||
        models_reports.alert_modal_report_new === "active") {
        return "active"
    } else {
        return "inactive";
    }
}

export const getDefaultValuesGeneral = () => {
    return {
        isVisible: "loading-wait",
        key_trimester: "",
        skip_channels: {},
        review_response_request : {},
        reservation_response_request : {},
        leadtime_response_request : {},
        occupancy_response_request : {},
        current_filter : "default",
        current_filter_time : {},
        current_filter_days : {},
        current_filter_dates : {},
        current_filter_dates_comp : {},
        current_filter_days_comp : {},
        filters_apply : [],
        filters_apply_backup : [],
        custom_calendar_active: "inactive", //[Pruebas] Debe ser "inactive"
        custom_list_report: "inactive", //[Pruebas] Debe ser "inactive"
        alert_datepicker_error: "inactive",
        alert_modal_report_list: "inactive",
        alert_modal_report_new: "inactive",
        status_reserve: [],
        hotels: [],
        segments: [],
        segments_reservation : [],
        view_results: "month",//[Pruebas] Debe ser "month"
        type_date: "date_book",
        current_year: current_year(),
        past_year: past_year(),
        base_year: current_year(),
        type_date_class: "",
        panel: "review", //[Pruebas] Debe ser review
        first_request: true,
        secondary_filter_bar: "inactive-secondary-bar",
        sidebar_review: {
            current_period: {
                key: "1 - 30 DAYS", value: "serie_30"
            },
            status: "",
            show: "hide"
        },
        status_sidebar: "inactive-sidebar",
        flash_summary_module : {
            interval_time_selected : '$month'
        },
        reservations_module : {
            interval_time_selected : '$month'
        },
        is_login: false,
    }
}
export const intervalDays = [  
    { key : "1 DAY",  value : 1 },
    { key : "2 DAYS", value : 2 },
    { key : "3 DAYS", value : 3 },
    { key : "4 DAYS", value : 4 },
    { key : "5 DAYS", value : 5 },
    { key : "6 DAYS", value : 6 },
    { key : "7 DAYS", value : 7 }
];

export const panelsReport = [  
    { key : "ALL",  value : 1 },
    { key: "FLASH SUMMARY",  value : 2 },
    { key: "RESERVATIONS PULSE", value : 3 },
    { key: "LEADTIME MNGT", value : 4 },
    { key: "OCCUPANCY STATS", value : 5 }
];

export const month_result_items = () => (
    {
        ENE : {
            items : [],
            hasMore : true,
            page:0,
            total:0,
            load:0
        },
        FEB : {
            items : [],
            hasMore : true,
            page:0,
            total:0,
            load:0
        },
        MAR : {
            items : [],
            hasMore : true,
            page:0,
            total:0,
            load:0
        },
        ABR : {
            items : [],
            hasMore : true,
            page:0,
            total:0,
            load:0
        },
        MAY : {
            items : [],
            hasMore : true,
            page:0,
            total:0,
            load:0
        },
        JUN : {
            items : [],
            hasMore : true,
            page:0,
            total:0,
            load:0
        },
        JUL : {
            items : [],
            hasMore : true,
            page:0,
            total:0,
            load:0
        },
        AGO : {
            items : [],
            hasMore : true,
            page:0,
            total:0,
            load:0
        },
        SEP : {
            items : [],
            hasMore : true,
            page:0,
            total:0,
            load:0
        },
        OCT : {
            items : [],
            hasMore : true,
            page:0,
            total:0,
            load:0
        },
        NOV : {
            items : [],
            hasMore : true,
            page:0,
            total:0,
            load:0
        },
        DIC : {
            items : [],
            hasMore : true,
            page:0,
            total:0,
            load:0
        },
    }
)
export function getWeek(d) {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
    // Return array of year and week number
    return [d.getUTCFullYear(), weekNo];
}

export function getColorLeadtime(key){
    let month_colors = {
        ENE:  '#013580',
        FEB:  '#1173C6',
        MAR: '#4CC8E2',
        ABR:  '#70BF4F',
        MAY: '#B2D63A',
        JUN:  '#F8D30E',
        JUL:  '#F8BC1C',
        AGO: '#FC603A',
        SEP:  '#D32613',
        OCT: '#BDC3C7',
        NOV: '#7B8D8D',
        DIC:  '#9B35B4'
    }
    return month_colors[key];
}
export function formatFriendlyDate(date){
    return (new Date(date).toDateString() === new Date().toDateString()) ? 'TODAY' : 'FEW DAY(S) AGO'
}

export function formatDate(date) {
    var monthNames = [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
    ];
    const day = date.getDate(),
    monthIndex = (date.getMonth() + 1), 
    year = date.getFullYear(),
    hour = date.getHours(),
    minutes = date.getMinutes(),
    seconds = date.getSeconds()
  
    return monthIndex + "/" + day + "/" + year + " at " + hour + ":" + minutes + ":" + seconds;
  }

  export function searchItem(value, objects){
    var results = -1;
    
    for(var i=0; i<objects.length; i++) {
      for(var key in objects[i]) {
        if(objects[i][key].indexOf(value)!=-1) {
          results = i;
        }
      }
    }
    return results
  }
  


// WEBPACK FOOTER //
// ./src/Frontend/config/Helpers.js